import { RouteComponentProps } from 'react-router';
import en from '../../../lang/en-us';
import { SubmitButton } from '../../../lib/Button';
import { getAmcList } from '../../../redux-store/actions/nct';
import { AMC_LIST_RESPONSE } from '../../../redux-store/types/nct';
import { transmissionOfUnitsPreLogin } from '../../../redux-store/actions/link';
import { connect } from 'react-redux';
import { useState, useEffect } from 'react';
const { dashboard, common } = en;
import {
    CircularProgress,
    Dialog,
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Button,
    SwipeableDrawer,
} from '@material-ui/core';
import { CLAIMANT, HOLDER, NOMINEE } from './transmission-request-holder';
interface TransmissionDownloadProps extends RouteComponentProps<any, any, any> {
    transmissionOfUnitsPreLogin: (body: any) => Promise<any>;
    getAmcList: () => Promise<any>;
}

type FOLIO_RESPONSE = {
    folio: string;
    amc: string;
    amount: string;
    noc: string;
};

type FinalizedData = {
    amc: string;
    noc: string;
    amount: number;
    folios: Array<string>;
    setNumber: number;
    [key: string]: any;
};
export type DOCUMNENTS = {
    title?: string;
    description?: string;
    download?: boolean;
    info?: string;
};
export const COMMON_DOCUMENTS: any = [
    {
        description:
            'Death Certificate original or Death certificate Photocopy duly attested by a Notary Public or Gazetted Officer.',
        title: 'Death Certificate',
        download: false,
    },
    {
        title: 'In case Claimant is Minor, please submit KYC form of the Guardian (If not already KYC complied).',
        description:
            'In case Claimant is Minor, please submit KYC form of the Guardian (If not already KYC complied).',
        download: false,
    },
    {
        title: 'In case claimant is Minor, please provide a Copy of Birth Certificate',
        description: 'In case claimant is Minor, please provide a Copy of Birth Certificate.',
        download: false,
    },
    {
        title: 'New Bank mandate',
        description:
            'New Bank mandate (with Cancelled cheque leaf with name and bank account number pre-printed OR copy of bank statement / Photocopy of Bank Passbook with current entries (not older than 3 months) attested by a Notary Public or a Gazetted Officer or Bank Manager).',
        download: false,
    },
    {
        title: 'Claimant KYC Form',
        description: 'Claimant KYC Form if it is identified that the Claimant is not KYC complied.',
        download: true,
        downloadLink: 'kyc-form.pdf',
    },
];
export const DOWNLOADED_FORMS: any = {
    [HOLDER]: [
        {
            title: 'T-2 Form',
            description: 'Duly filled in and Signed Form T-2.',
            download: true,
            downloadLink: 'T2Form.pdf',
        },
        ...COMMON_DOCUMENTS,
        {
            title: 'Nomination Form',
            description: 'Nomination Form.',
            download: true,
            downloadLink: 'NominationForm.pdf',
        },
    ],
    [NOMINEE]: [
        {
            title: 'T-3 Form',
            description: 'Duly filled in and Signed Form T-3.',
            download: true,
            downloadLink: 'T3Form.pdf',
        },
        ...COMMON_DOCUMENTS,
        {
            title: 'Bank Attestation of Signature of the Claimant/ Guardian',
            description:
                'Bank Attestation of Signature of the Claimant/ Guardian (in case the Claimant is a minor) by the Bank Manager as per Annexure-Ia (Annexure Ia to be enclosed) where Transmission value upto 200,000.',
            download: true,
            downloadLink: 'Annexure-Ia_BankAttestationofSignatureBankaccountdetails.pdf',
        },
    ],
    [CLAIMANT]: {
        ['BTL']: [
            {
                title: 'T-3 Form',
                description: 'Duly filled in and Signed Form T-3.',
                download: true,
                downloadLink: 'T3Form.pdf',
            },
            ...COMMON_DOCUMENTS,
            {
                title: 'Indemnity Bond duly signed and executed by all legal heir/sconfirming the claimants - duly notarised (Annexure II to be enclosed)',
                description:
                    'Indemnity Bond duly signed and executed by all legal heir/sconfirming the claimants - duly notarised (Annexure II to be enclosed).',
                download: true,
                downloadLink: 'Annexure-II.pdf',
            },
            {
                title: ' Individual Affidavit by all legal heir/s - duly Notarised (Annexure III to be enclosed)',
                description:
                    ' Individual Affidavit by all legal heir/s - duly Notarised (Annexure III to be enclosed).',
                download: true,
                downloadLink: 'Annexure-III_IndividualAffidavitstobegivenbyALLtheLegalHeirs.pdf',
            },
            {
                title: 'Document evidencing relationship of the claimant/s with the deceased unitholder/s',
                description:
                    'Document evidencing relationship of the claimant/s with the deceased unitholder/s.',
            },
            {
                title: 'NOC from other Legal Heirs (Annexure IV to be enclosed)',
                description: 'NOC from other Legal Heirs (Annexure IV to be enclosed).',
                download: true,
                downloadLink: 'Annexure-IV_NOCfromotherlegalheirs.pdf',
            },
        ],
        ['ABTL']: [
            {
                title: 'T-3 Form',
                description: 'Duly filled in and Signed Form T-3.',
                download: true,
                downloadLink: 'T3Form.pdf',
            },
            ...COMMON_DOCUMENTS,
            {
                title: 'Bank Attestation',
                description:
                    'Bank Attestation of Signature of the Claimant/ Guardian (in case the Claimant is a minor) by the Bank Manager as per Annexure-Ia (Annexure -Ia to be enclosed).',
                download: true,
                downloadLink: 'Annexure-Ia_BankAttestationofSignatureBankaccountdetails.pdf',
            },
            {
                title: ' Individual Affidavit by all legal heir/s - duly Notarised (Annexure III to be enclosed)',
                description:
                    ' Individual Affidavit by all legal heir/s - duly Notarised (Annexure III to be enclosed).',
                download: true,
                downloadLink: 'Annexure-III_IndividualAffidavitstobegivenbyALLtheLegalHeirs.pdf',
            },
            {
                title: 'Notarised Copy',
                description:
                    'Notarised copy of the Probated Will OR Notarised copy Legal Heir certificate or Succession certificate issued by a competent court OR Notarised copy Letter of Administration, in case of an intestate Succession.',
                download: false,
            },
        ],
    },
};
const groupByAmcandNoc = (arr: FOLIO_RESPONSE[]) => {
    let newArr = arr.reduce((acc: any, curr) => {
        if (!curr.noc) {
            return acc;
        }
        let key = `${curr.noc}_${curr.amc}`;
        acc[key] = [...(acc[key] || []), curr];
        return acc;
    }, []);
    return newArr;
};

const spreadAmcs = (arr: any) => {
    arr = Object.keys(arr).map((key) => {
        let currFolios = arr[key];
        let folioNumbers: any = [];
        let amount = 0;
        currFolios.forEach((folio: any) => {
            folioNumbers.push(folio.folio);
            amount += !!parseInt(folio.amount) ? parseInt(folio.amount) : 0;
        });
        return {
            amc: key.split('_')[1],
            noc: key.split('_')[0],
            amount: amount,
            folios: folioNumbers,
        };
    });
    return arr;
};

const groupByNoc = (arr: FinalizedData[]) => {
    let groupedByNocs: any = {
        claimant: [] as FinalizedData[],
        nominee: [] as FinalizedData[],
        holder: [] as FinalizedData[],
    };
    let amcGroup = arr.reduce((prev, curr) => {
        let key = curr.noc == HOLDER ? 'holder' : curr.noc.toLowerCase();
        return { ...prev, [key]: [...(prev[key] || []), curr] };
    }, groupedByNocs);
    return amcGroup;
};

type RenderDocumentsProps = {
    noc: string;
    rowSpan?: number;
    index?: number;
    amount: number;
    isClaimant: boolean;
};

function TransmissionDownloadList(props: TransmissionDownloadProps) {
    // let fixture_amcs: FOLIO_RESPONSE[] = [
    //     { folio: '1233', amc: 'Test1', amount: '250000', noc: 'claimant' },
    //     { folio: '2233', amc: 'Test1', amount: '23500', noc: 'claimant' },
    //     { folio: '1234', amc: 'Test2', amount: '112300', noc: 'claimant' },
    //     { folio: '1235', amc: 'Test3', amount: '123500', noc: 'holder' },
    //     { folio: '1235', amc: 'Test6', amount: '123500', noc: 'holder' },
    //     { folio: '1236', amc: 'Test4', amount: '13500', noc: 'claimant' },
    //     { folio: '1237', amc: 'Test2', amount: '143500', noc: 'nominee' },
    // ];

    const [openDrawer, setDrawer] = useState<boolean>(false);
    const [amcList, setAmcList] = useState<AMC_LIST_RESPONSE[]>([]);
    const [mobileNoc, setMobileNoc] = useState<string>('');
    const [mobileAmount, setMobileAmount] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);

    const { reqId, pan, mobile, email, data, amcs } = props.location.state || {};

    useEffect(() => {
        if (!props.location.state || !reqId || !email || !pan || !mobile || !data || !amcs) {
            props.history.replace('/');
        }
        async function callApi() {
            try {
                let { body = [] } = await props.getAmcList();
                setAmcList(body);
            } catch (err: any) {
                alert(err.message);
            }
        }
        callApi();
    }, []);

    const RenderDocuments = ({ noc, rowSpan, amount, index, isClaimant }: RenderDocumentsProps) => {
        let dl_doc = DOWNLOADED_FORMS;
        let lineNum = 1;
        let dl_doc_obj = dl_doc[noc];

        if (isClaimant) {
            if (amount <= 200000) {
                dl_doc_obj = dl_doc[CLAIMANT]['BTL'];
            } else {
                dl_doc_obj = dl_doc[CLAIMANT]['ABTL'];
            }
        }
        //render only the first time
        // if (index !== 0) {
        //     return null;
        // }
        // dl_doc_obj = dl_doc[noc];

        return (
            <TableCell className="documents-required">
                {dl_doc_obj.map((doc: any, index: number) => {
                    return (
                        <div key={lineNum}>
                            <div className="transmission-download-list-number">
                                <img src="/images/document-bg.svg" alt="icon" />
                                <span>{lineNum++}</span>
                            </div>
                            <p>
                                {' '}
                                {doc.description} {doc.info ? <span> {doc.info} </span> : null}
                                {doc.download && (
                                    <span
                                        style={{ cursor: 'pointer' }}
                                        onClick={
                                            () => {
                                                window.open(
                                                    `${process.env.REACT_APP_S3_CLOUD_URL}/${doc.downloadLink}`,
                                                    '_system',
                                                );
                                            }
                                        }
                                    >
                                        Download
                                    </span>
                                )}
                            </p>
                        </div>
                    );
                })}
            </TableCell>
        );
    };

    const RenderMobileDocuments = ({ noc, rowSpan, amount, isClaimant }: RenderDocumentsProps) => {
        let dl_doc = DOWNLOADED_FORMS;
        let lineNum = 1;
        let dl_doc_obj;

        if (isClaimant) {
            if (amount <= 200000) {
                dl_doc_obj = dl_doc[CLAIMANT]['BTL'];
            } else dl_doc_obj = dl_doc[CLAIMANT]['ABTL'];

            return (
                <div className="documents-required">
                    <h4>{dashboard.TransmissionRequest.downloadList.documentRequired}</h4>
                    {dl_doc_obj.map((doc: any, index: number) => {
                        return (
                            <div key={lineNum}>
                                <div className="transmission-download-list-number">
                                    <img src="/images/document-bg.svg" alt="icon" />
                                    <span>{lineNum++}</span>
                                </div>
                                <p>
                                    {' '}
                                    {doc.description} {doc.info ? <span> {doc.info} </span> : null}
                                    {doc.download && (
                                        <span
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => {
                                                window.open(
                                                    `${process.env.REACT_APP_S3_CLOUD_URL}/${doc.downloadLink}`,
                                                    '_system',
                                                );
                                            }}
                                        >
                                            Download
                                        </span>
                                    )}
                                </p>
                            </div>
                        );
                    })
                    }
                </div >
            );
        }

        dl_doc_obj = dl_doc[noc];

        return (
            <div className="documents-required">
                {dl_doc_obj.map((doc: any, index: number) => {
                    return (
                        <div key={lineNum}>
                            <div className="transmission-download-list-number">
                                <img src="/images/document-bg.svg" alt="icon" />
                                <span>{lineNum++}</span>
                            </div>
                            <p>
                                {' '}
                                {doc.description} {doc.info ? <span> {doc.info} </span> : null}
                                {doc.download && (
                                    <span
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            window.open(
                                                `${process.env.REACT_APP_S3_CLOUD_URL}/${doc.downloadLink}`,
                                                '_system',
                                            );
                                        }}
                                    >
                                        Download
                                    </span>
                                )}
                            </p>
                        </div>
                    );
                })}
            </div>
        );
    };

    // console.log(amcs);

    let mobileData = spreadAmcs(groupByAmcandNoc(amcs));
    let finalizedData = groupByNoc(mobileData);
    let setNumber = 1;

    let { images } = props.location.state || {};

    const getAmcString = (amc: string) => {
        try {
            return amcList.filter((ele) => {
                if (ele.amc_code == amc) {
                    return ele.amc_name;
                }
            })[0].amc_name;
        } catch (err) {
            return 'NONE';
        }
    };

    const handleSubmit = async () => {
        try {
            images = images.map((image: any, index: number) => {
                return {
                    ...image,
                    content: localStorage.getItem(`deathCertificate${index + 1}`),
                };
            });
            data.forEach((item: any, index: number) => {
                let documents = '';
                if (item.natureOfClaimant === CLAIMANT) {
                    let amount =
                        finalizedData[CLAIMANT.toLowerCase()].find(
                            (ele: any) => ele.amc === getAmcString(item.amc),
                        )?.amount || 0;
                    if (amount <= 200000) {
                        DOWNLOADED_FORMS[CLAIMANT]['BTL'].forEach((doc: any) => {
                            documents += doc.description + ',';
                        });
                    } else {
                        DOWNLOADED_FORMS[CLAIMANT]['ABTL'].forEach((doc: any) => {
                            documents += doc.description + ',';
                        });
                    }
                } else if (item.natureOfClaimant === NOMINEE) {
                    DOWNLOADED_FORMS[NOMINEE].forEach((doc: any) => {
                        documents += doc.description + ',';
                    });
                } else {
                    DOWNLOADED_FORMS[HOLDER].forEach((doc: any) => {
                        documents += doc.description + ',';
                    });
                }
                data[index].documents = documents.slice(0, -1);
            });
            const payload: any = {
                reqId,
                pan,
                pekrn: '',
                mobile,
                email,
                images,
                data: [...data],
            };
            setLoading(true);
            let res = await props.transmissionOfUnitsPreLogin(payload);
            props.history.replace('transmission-request-success', {
                ...props.location.state,
                reqId: res.body.reqId.toString(),
                data,
            });
        } catch (err: any) {
            alert(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="curved-bg">
            {/* <ActionHeader header={dashboard.TransmissionRequest.TransmissionRequestHeading} /> */}
            <h2 className="heading">
                <a onClick={() => props.history.goBack()}>
                    <img src="/images/left-arrow-black.svg" alt="icon" />
                </a>
                {dashboard.TransmissionRequest.TransmissionUnitHeading}
            </h2>
            <div className="curved-bg-content curved-bg-table-outer transmission-request transmission-download-list">
                <div className="curved-bg-content-inner">
                    <div className="transmission-download-content">
                        <div className="transmission-download-content-top">
                            <img
                                className="transmission-download-character"
                                src="/images/transmission-download-character.png"
                                alt="icon"
                            />
                            <p>{dashboard.TransmissionRequest.downloadList.mainInfo}</p>
                            <img src="/images/transmission-download-building.png" alt="icon" />
                        </div>
                        {/* <div className="transmission-download-content-bottom">
                            {forms.map((document, index) => (
                                <div key={index} className="transmission-download-list-documents">
                                    <div className="transmission-download-list-number">
                                        <p>
                                            <img src="/images/document-bg.svg" alt="icon" />
                                            <span>{index + 1}</span>
                                        </p>
                                    </div>
                                    <div className="transmission-download-list-txt">
                                        <h5>{document.description || document.title}</h5>
                                        <p>{document.info}</p>
                                    </div>
                                </div>
                            ))}
                        </div> */}
                    </div>
                    <div className="desktop_mode">
                        <TableContainer>
                            <Table className="transmission-download-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            {
                                                dashboard.TransmissionRequest.downloadList
                                                    .natureOfClaim
                                            }
                                        </TableCell>
                                        <TableCell>
                                            {dashboard.TransmissionRequest.downloadList.documentSet}
                                        </TableCell>
                                        <TableCell>
                                            {dashboard.TransmissionRequest.downloadList.fundFolios}
                                        </TableCell>
                                        <TableCell>
                                            {
                                                dashboard.TransmissionRequest.downloadList
                                                    .documentRequired
                                            }
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {finalizedData.claimant.map(
                                        (data: FinalizedData, index: number) => (
                                            <TableRow key={index}>
                                                {index == 0 ? (
                                                    <TableCell
                                                        rowSpan={finalizedData.claimant.length}
                                                    >
                                                        <h4>
                                                            {
                                                                dashboard.TransmissionRequest
                                                                    .downloadList.claimant
                                                            }
                                                        </h4>
                                                        <p>
                                                            {
                                                                dashboard.TransmissionRequest
                                                                    .downloadList.claimantInfo
                                                            }
                                                        </p>
                                                    </TableCell>
                                                ) : null}
                                                <TableCell className="document-set">
                                                    Set {setNumber++}{' '}
                                                </TableCell>
                                                <TableCell className="funds">
                                                    <h4>{data.amc}</h4>
                                                    <p>
                                                        {
                                                            dashboard.TransmissionRequest
                                                                .downloadList.folios
                                                        }
                                                    </p>{' '}
                                                    <div>
                                                        {/* <span>{data.folios.join(',')}</span> */}
                                                        {data.folios.map((folio) => (
                                                            <span> {folio} </span>
                                                        ))}
                                                    </div>
                                                </TableCell>
                                                <RenderDocuments
                                                    amount={data.amount}
                                                    noc={CLAIMANT}
                                                    rowSpan={finalizedData.claimant.length}
                                                    index={index}
                                                    isClaimant={true}
                                                />
                                            </TableRow>
                                        ),
                                    )}
                                    {finalizedData.holder.map(
                                        (data: FinalizedData, index: number) => (
                                            <TableRow key={index}>
                                                {index == 0 ? (
                                                    <TableCell
                                                        rowSpan={finalizedData.holder.length}
                                                    >
                                                        <h4>
                                                            {
                                                                dashboard.TransmissionRequest
                                                                    .downloadList.holder
                                                            }
                                                        </h4>
                                                    </TableCell>
                                                ) : null}
                                                <TableCell className="document-set">
                                                    Set {setNumber++}{' '}
                                                </TableCell>
                                                <TableCell className="funds">
                                                    <h4>{data.amc}</h4>
                                                    <p>
                                                        {
                                                            dashboard.TransmissionRequest
                                                                .downloadList.folios
                                                        }
                                                    </p>{' '}
                                                    <div>
                                                        {data.folios.map((folio) => (
                                                            <span> {folio} </span>
                                                        ))}
                                                    </div>
                                                </TableCell>
                                                <RenderDocuments
                                                    amount={data.amount}
                                                    noc={HOLDER}
                                                    rowSpan={finalizedData.holder.length}
                                                    index={index}
                                                    isClaimant={false}
                                                />
                                            </TableRow>
                                        ),
                                    )}
                                    {finalizedData.nominee.map(
                                        (data: FinalizedData, index: number) => (
                                            <TableRow key={index}>
                                                {index == 0 ? (
                                                    <TableCell
                                                        rowSpan={finalizedData.nominee.length}
                                                    >
                                                        <h4>
                                                            {
                                                                dashboard.TransmissionRequest
                                                                    .downloadList.nominee
                                                            }
                                                        </h4>
                                                    </TableCell>
                                                ) : null}
                                                <TableCell className="document-set">
                                                    Set {setNumber++}{' '}
                                                </TableCell>
                                                <TableCell className="funds">
                                                    <h4>{data.amc}</h4>
                                                    <p>
                                                        {
                                                            dashboard.TransmissionRequest
                                                                .downloadList.folios
                                                        }
                                                    </p>{' '}
                                                    <div>
                                                        {data.folios.map((folio) => (
                                                            <span> {folio} </span>
                                                        ))}
                                                    </div>
                                                </TableCell>
                                                <RenderDocuments
                                                    amount={data.amount}
                                                    noc={NOMINEE}
                                                    rowSpan={finalizedData.nominee.length}
                                                    index={index}
                                                    isClaimant={false}
                                                />
                                            </TableRow>
                                        ),
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                    <div className="mobile_mode">
                        <div className="transmission-download-mobile">
                            {mobileData.map((data: any, index: number) => (
                                <div className="transmission-download-mobile-single">
                                    <div className="nature-of-claim">
                                        <h4>
                                            {
                                                dashboard.TransmissionRequest.downloadList
                                                    .natureOfClaim
                                            }
                                            :{' '}
                                            <span>{data.noc === HOLDER ? 'Holder' : data.noc}</span>
                                        </h4>
                                        <p>
                                            {data.noc == CLAIMANT
                                                ? dashboard.TransmissionRequest.downloadList
                                                    .claimantInfo
                                                : null}
                                        </p>
                                    </div>
                                    <div className="funds">
                                        <h4>{data.amc}</h4>
                                        <p>{dashboard.TransmissionRequest.downloadList.folios}</p>
                                        <div>
                                            {data.folios.map((folio: any) => (
                                                <span> {folio} </span>
                                            ))}
                                        </div>
                                    </div>
                                    <a
                                        className="view-documents"
                                        onClick={() => {
                                            if (openDrawer === false) {
                                                setDrawer(true);
                                                setMobileNoc(data.noc);
                                                setMobileAmount(data.amount);
                                            }
                                        }}
                                    >
                                        {
                                            dashboard.TransmissionRequest.downloadList
                                                .viewDocumentsRequired
                                        }
                                    </a>
                                </div>
                            ))}

                            <SwipeableDrawer
                                className="documents-mobile-drawer"
                                anchor={'bottom'}
                                open={openDrawer}
                                onClose={() => setDrawer(false)}
                                onOpen={() => setDrawer(true)}
                            >
                                <div className="transmission-documents-required-drawer">
                                    <RenderMobileDocuments
                                        isClaimant={mobileNoc === CLAIMANT}
                                        amount={mobileAmount}
                                        noc={mobileNoc}
                                    />
                                    <div className="btns">
                                        <Button className="customBtn">
                                            <a onClick={() => setDrawer(false)}>
                                                {dashboard.TransmissionRequest.downloadList.okay}
                                            </a>{' '}
                                        </Button>
                                    </div>
                                </div>
                            </SwipeableDrawer>
                        </div>
                    </div>
                    <Dialog
                        maxWidth={'sm'}
                        open={loading}
                        aria-labelledby="enable-fingerprint-modal"
                    >
                        <div className="enable-fingerprint-modal">
                            <CircularProgress />
                            <p>{'Please wait...'}</p>
                        </div>
                    </Dialog>
                    <div className="curved-bg-content-inner-bottom">
                        <SubmitButton
                            onClick={handleSubmit}
                            label={dashboard.TransmissionRequest.downloadList.doneBtn}
                            className="customBtn"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
export default connect(null, { transmissionOfUnitsPreLogin, getAmcList })(TransmissionDownloadList);
